<template>
  <div class="form">
    <div class="content">
      <p class="page-title">{{ $route.name }}</p>
      <button @click="save()" class="btn fixed_btn">Save</button>
      <div class="card" v-if="ad">
        <div class="inputs">
          <div class="switch-holder">
            <span style="margin-right: 15px">{{ ad.active ? "Active" : "Inactive" }}</span>
            <switches v-model="ad.active"></switches>
          </div>
          <div class="input">
            <label>Ad Name</label>
            <input v-model="ad.name" />
          </div>
          <div class="input">
            <label>Ad Duration (seconds)</label>
            <input class="duration" type="number" v-model="ad.duration" />
          </div>
          <div class="input full">
            <label>
              Ad Image / Video
              <span>Ideal size (1080px x 855px)</span>
            </label>
            <file-upload
              :full="true"
              @removeImage="ad.media = null"
              @uploadImage="uploadImage"
              :media="ad.media"
              :type="ad.type"
              directory="Kiosk Ad"
            />
          </div>
          <div class="btns left">
            <button @click="save()" class="btn round-btn">Save</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import Swal from "sweetalert2";
import Switches from "vue-switches";
const fb = require("../firebaseConfig.js");
const db = fb.default.db;
const storage = fb.default.storage;
const auth = fb.default.auth;

export default {
  name: "KioskAd",
  components: {
    Switches
  },
  data() {
    return {
      ad: null
    };
  },
  created() {
    db.collection("user")
      .doc(this.user_doc.id)
      .collection("kiosk_ads")
      .doc(this.$route.params.id)
      .get()
      .then(doc => {
        if (doc.exists) {
          this.ad = doc.data();
        } else {
          this.ad = {
            media: null,
            type: null,
            duration: 30,
            active: true,
            name: null,
            order: 1
          };
        }
      });
  },
  methods: {
    uploadImage(payload) {
      this.ad.media = payload.url;
      this.ad.type = payload.type;
    },
    save() {
      if (this.ad.media) {
        db.collection("user")
          .doc(this.user_doc.id)
          .collection("kiosk_ads")
          .doc(this.$route.params.id)
          .set(this.ad)
          .then(() => {
            Swal.fire("Ad Saved").then(() => {
              this.$router.go(-1);
            });
          });
      } else {
        Swal.fire("Please add an image or video");
      }
    }
  }
};
</script>

<style scoped lang="scss">
.switch-holder {
  width: 100%;
  margin-bottom: 20px;
}

label span {
  opacity: 0.5;
  margin-left: 10px;
}

.duration {
  max-width: 100px;
}
</style>
